<template>
  <v-card
    class="further-questions-banner elevation-11"
    :class="{ 'container-mobile': this.isMobile }"
  >
    <div class="inner-container d-flex flex-column justify-center align-center">
      <v-row class="d-flex align-center justify-center image-row">
        <v-img class="image" :src="this.questionMark" contain />
      </v-row>
      <v-row class="mb-9 mt-0">
        <span
          >Do you have any further
          <span style="font-weight: 600">questions?</span></span
        >
      </v-row>
      <v-row class="d-flex align-center justify-center btn-container">
        <FunkButton
          :class="{ active: selection === 'no' }"
          class="mr-3"
          button-text="No, I Am Good"
          @buttonClicked="inform(false)"
        ></FunkButton>
        <FunkButton
          :class="{ active: selection === 'yes' }"
          button-text="Yes, I Do"
          @buttonClicked="inform(true)"
        ></FunkButton>
      </v-row>

      <v-row
        v-if="informDataVisibleNo"
        class="information-list d-flex flex-column"
      >
        <p>
          That’s great,if you need any further information in the future or have
          specific questions please visit our FAQs & Articles sections.
        </p>
        <div class="d-flex justify-center">
          <GradientButton
            class="learn-more-button"
            @gradientButtonClicked="learnMore"
            :title="'Learn More'"
            :callout="'right'"
          />
        </div>
      </v-row>
      <v-row
        v-if="informDataVisibleYes"
        class="information-list d-flex flex-column"
      >
        <p>
          That’s great, if you need any further information in the future or
          have specific questions please visit our FAQs & Articles sections.
        </p>
        <div class="d-flex justify-center">
          <GradientButton
            class="learn-more-button"
            @gradientButtonClicked="learnMore"
            :title="'Learn More'"
            :callout="'right'"
          />
        </div>
      </v-row>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'FurtherQuestionsBanner',
    data() {
      return {
        questionMark: require(`@/assets/shared/redesign/icons/question-mark.svg`),
        informDataVisibleNo: false,
        informDataVisibleYes: false,
        selection: null,
      };
    },
    methods: {
      learnMore() {
        this.$router.push({ name: 'Articles' });
      },
      inform(answer) {
        if (answer) {
          this.selection = 'yes';
          this.informDataVisibleNo = false;
          this.informDataVisibleYes = !this.informDataVisibleYes;
        } else {
          this.selection = 'no';
          this.informDataVisibleYes = false;
          this.informDataVisibleNo = !this.informDataVisibleNo;
        }
      },
    },
    computed: {
      isMobile() {
        return this.$isMobileDevice();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .further-questions-banner {
    background-color: white;
    padding: 48px 159px 48px 159px;

    &.container-mobile {
      height: 100%;
      padding: 40px 20px 50px 20px !important;
      .btn-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
    }

    .inner-container {
      height: 100%;
      margin: 11px;

      .image-row {
        margin-bottom: 48px;
      }

      .info-title {
        padding: 0 0 14px 5px;
      }

      .learn-more-button {
        margin-top: 36px;
      }
    }
  }

  .information-list {
    padding: 36px 36px 0 36px;
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }

  @media screen and (max-width: 600px) {
    .further-questions-banner {
      &.container-mobile {
        padding: 48px 12px 52px 12px;
      }
    }
  }
</style>
